__turbopack_context__.v({
  "description": "EmptyState-module__rWaS3q__description",
  "icon": "EmptyState-module__rWaS3q__icon",
  "root": "EmptyState-module__rWaS3q__root",
  "title": "EmptyState-module__rWaS3q__title",
});
